export default "__VITE_ASSET__CLxu8pf$__"